/* eslint-disable */
/* tslint:disable */

/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
import {
  EligibilityDeterminationInput,
  UpdatePersonInput,
  ApplicationHouseholdMembersInput,
  NjmmisCheckResult,
  Benefit,
  McdType,
  McdSubtype,
  SlideType,
} from './globalTypes' // ====================================================
// GraphQL mutation operation: SaveEligibilityDeterminations
// ====================================================

import {deserializeApplicationHouseholdMembersInput} from './globalTypes'
import {serializeApplicationHouseholdMembersInput} from './globalTypes'
import {deserializeUpdatePersonInput} from './globalTypes'
import {serializeUpdatePersonInput} from './globalTypes'
import {deserializeEligibilityDeterminationInput} from './globalTypes'
import {serializeEligibilityDeterminationInput} from './globalTypes'
import {SaveEligibilityDeterminationsVariables as SaveEligibilityDeterminationsVariablesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations as SaveEligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount as SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccountOrig} from '../types/SaveEligibilityDeterminations'
import {WebformMergeResult} from 'utils/form/getWebformMergeResult'
import {parseWebformMergeResult} from 'utils/form/getWebformMergeResult'
import {serializeWebformMergeResult} from 'utils/form/getWebformMergeResult'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts as SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttemptsOrig} from '../types/SaveEligibilityDeterminations'
import {ReceivedWebformResponse} from 'utils/form/getReceivedWebformResponse'
import {parseReceivedWebformResponse} from 'utils/form/getReceivedWebformResponse'
import {serializeReceivedWebformResponse} from 'utils/form/getReceivedWebformResponse'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform as SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebformOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform as SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webformOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks as SaveEligibilityDeterminations_saveEligibilityDeterminations_tasksOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy as SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdByOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_accounts as SaveEligibilityDeterminations_saveEligibilityDeterminations_accountsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles as SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFilesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContactOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationshipsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPersonOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationshipsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPersonOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationshipsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPersonOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationshipsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPersonOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationshipsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPersonOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documentsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_filesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContactOrig} from '../types/SaveEligibilityDeterminations'
import {deserializeMcdSubtype} from 'graphql/converters'
import {serializeMcdSubtype} from 'graphql/converters'
import {deserializeMcdType} from 'graphql/converters'
import {serializeMcdType} from 'graphql/converters'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {BenefitType} from 'utils/benefits'
import {deserializeBenefit} from 'graphql/converters'
import {serializeBenefit} from 'graphql/converters'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_applicationOrig} from '../types/SaveEligibilityDeterminations'
import {deserializeSlideType} from 'graphql/converters'
import {serializeSlideType} from 'graphql/converters'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSessionOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards as SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationshipsOrig} from '../types/SaveEligibilityDeterminations'
import {DeserializedFieldsUpdatedAt} from 'utils/form/getFieldsUpdatedAt'
import {parseFieldsUpdatedAt} from 'utils/form/getFieldsUpdatedAt'
import {serializeFieldsUpdatedAt} from 'utils/form/getFieldsUpdatedAt'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPersonOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplicationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_personOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages as SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriagesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account as SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_accountOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_triages as SaveEligibilityDeterminations_saveEligibilityDeterminations_triagesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo as SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedToOrig} from '../types/SaveEligibilityDeterminations'
import {AdditionalData} from 'utils/getAdditionalData'
import {parseAdditionalData} from 'utils/getAdditionalData'
import {serializeAdditionalData} from 'utils/getAdditionalData'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations as SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminationsOrig} from '../types/SaveEligibilityDeterminations'
import {deserializeNjmmisCheckResult} from 'graphql/converters'
import {serializeNjmmisCheckResult} from 'graphql/converters'
import formatISO from 'date-fns/formatISO'
import {parseDate} from 'utils/form/fieldTypes'
import {formatISODate} from 'utils/date'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account as SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_accountOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_assets as SaveEligibilityDeterminations_saveEligibilityDeterminations_assetsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_deductions as SaveEligibilityDeterminations_saveEligibilityDeterminations_deductionsOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources as SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSourcesOrig} from '../types/SaveEligibilityDeterminations'
import {SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers as SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbersOrig} from '../types/SaveEligibilityDeterminations'
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_accountOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_accountOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_triages {
  __typename: 'Triage'
  id: string
  account: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account
  createdAt: Date
  updatedAt: Date
  status: string
  closeReason: string | null
  closeComment: string | null
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations[]
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triagesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triages => ({
  ...serialized,
  account: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account(
    serialized.account
  ),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages
): SaveEligibilityDeterminations_saveEligibilityDeterminations_triagesOrig => ({
  ...deserialized,
  account: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_account(
    deserialized.account
  ),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_eligibilityDeterminations
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_accountOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_accountOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages {
  __typename: 'Triage'
  id: string
  status: string
  account: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriagesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages => ({
  ...serialized,
  account: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account(
    serialized.account
  ),
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriagesOrig => ({
  ...deserialized,
  account: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_account(
    deserialized.account
  ),
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages_eligibilityDeterminations
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplicationsOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPersonOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationshipsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships => ({
  ...serialized,
  otherPerson: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships
): SaveEligibilityDeterminations_saveEligibilityDeterminations_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes[]
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo | null
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication_householdMembers
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContactOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes[]
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo | null
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication_householdMembers
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes[]
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo | null
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication_householdMembers
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes[]
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo | null
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication_householdMembers
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbersOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication {
  __typename:
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  charityCareType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  slideType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  slideType: deserializeSlideType(serialized.slideType),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  slideType: serializeSlideType(deserialized.slideType),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication' ||
    serialized.__typename === 'RyanWhiteApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_applicationOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication' ||
    deserialized.__typename === 'RyanWhiteApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards {
  __typename: 'EsignWizard'
  id: string
  completedAt: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards => ({
  ...serialized,
  completedAt:
    serialized.completedAt != null
      ? parseDate(serialized.completedAt)
      : serialized.completedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizardsOrig => ({
  ...deserialized,
  completedAt:
    deserialized.completedAt != null
      ? formatISO(deserialized.completedAt)
      : deserialized.completedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession {
  __typename: 'EsignSession'
  id: string
  unreviewed: boolean | null
  esignWizards: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSessionOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession => ({
  ...serialized,
  esignWizards: serialized.esignWizards.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSessionOrig => ({
  ...deserialized,
  esignWizards: deserialized.esignWizards.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession_esignWizards
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
  esignSession: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources => ({
  ...serialized,
  esignSession:
    serialized.esignSession != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession(
          serialized.esignSession
        )
      : serialized.esignSession,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSourcesOrig => ({
  ...deserialized,
  esignSession:
    deserialized.esignSession != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources_esignSession(
          deserialized.esignSession
        )
      : deserialized.esignSession,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
  dob: Date | null
  ssn: string | null
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers[]
  preferredLanguage: string | null
  benefitOutcomes: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes[]
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions[]
  email: string | null
  hospitalPatientId: string | null
  unreadMessageStatus: boolean | null
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person => ({
  ...serialized,
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions
  ),
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_benefitOutcomes
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_deductions
  ),
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  wantsCoverage: boolean | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo | null
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person(
    serialized.person
  ),
  assignedTo:
    serialized.assignedTo != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo(
          serialized.assignedTo
        )
      : serialized.assignedTo,
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
  assignedTo:
    deserialized.assignedTo != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_assignedTo(
          deserialized.assignedTo
        )
      : deserialized.assignedTo,
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication_householdMembers
  ),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations[]
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents[]
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents
  ),
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_documents
  ),
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContactOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations[]
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents[]
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents
  ),
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_documents
  ),
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations[]
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents[]
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents
  ),
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_documents
  ),
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations[]
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents[]
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents
  ),
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_documents
  ),
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  eligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations[]
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents[]
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  eligibilityDeterminations: serialized.eligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents
  ),
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  eligibilityDeterminations: deserialized.eligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_eligibilityDeterminations
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_documents
  ),
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPersonOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationshipsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person_relationships
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication_documents
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPersonOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationshipsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person_relationships
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication_documents
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPersonOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationshipsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person_relationships
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication_documents
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPersonOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationshipsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person_relationships
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication_documents
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers {
  __typename: 'PhoneNumber'
  id: string
  number: string
  language: string | null
  comment: string | null
  usedInApp: boolean | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbersOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources {
  __typename: 'IncomeSource'
  id: string
  incomeType: string | null
  employerName: string | null
  employerAddressStreet: string | null
  employerAddressCity: string | null
  employerAddressState: string | null
  employerAddressZip: string | null
  employerPhone: string | null
  employerInsurance: boolean | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  fullPartTime: string | null
  amount: number | null
  payFrequency: string | null
  usedForEsign: boolean | null
  esignSessionId: string | null
  esignSessionStatus: string | null
  esignSessionUrl: string | null
  proofOfIncome: boolean | null
  noProofOfIncomeReason: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSourcesOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions {
  __typename: 'Deduction'
  id: string
  deductionType: string | null
  startMonth: string | null
  startYear: string | null
  endMonth: string | null
  endYear: string | null
  amount: number | null
  deductionFrequency: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductionsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets {
  __typename: 'Asset'
  id: string
  assetType: string | null
  amount: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assetsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assetsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPersonOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPersonOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships {
  __typename: 'Relationship'
  id: string
  relationshipType: string | null
  otherPerson: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson
  liveTogether: boolean | null
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationshipsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships => ({
  ...serialized,
  otherPerson: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson(
    serialized.otherPerson
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationshipsOrig => ({
  ...deserialized,
  otherPerson: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships_otherPerson(
    deserialized.otherPerson
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  relationships: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  relationships: serialized.relationships.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  relationships: deserialized.relationships.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person_relationships
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers {
  __typename: 'ApplicationHouseholdMember'
  id: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembersOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers => ({
  ...serialized,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembersOrig => ({
  ...deserialized,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_filesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_filesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_personOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_applicationOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents {
  __typename: 'Document'
  id: string
  documentType: string
  complete: boolean | null
  files: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files[]
  updatedAt: Date
  notes: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person | null
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents => ({
  ...serialized,
  files: serialized.files.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: parseDate(serialized.updatedAt),
  person:
    serialized.person != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person(
          serialized.person
        )
      : serialized.person,
  application: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application(
    serialized.application
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documentsOrig => ({
  ...deserialized,
  files: deserialized.files.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_files
  ),
  updatedAt: formatISO(deserialized.updatedAt),
  person:
    deserialized.person != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_person(
          deserialized.person
        )
      : deserialized.person,
  application: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents_application(
    deserialized.application
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person
  householdMembers: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers[]
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person(
    serialized.person
  ),
  householdMembers: serialized.householdMembers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers
  ),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
  householdMembers: deserialized.householdMembers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_householdMembers
  ),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication_documents
  ),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContactOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication_person(
    deserialized.person
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication {
  __typename: 'MedicaidApplication' | 'MonitorApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  facility: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications => {
  if (
    false ||
    serialized.__typename === 'MedicaidApplication' ||
    serialized.__typename === 'MonitorApplication'
  )
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplicationsOrig => {
  if (
    false ||
    deserialized.__typename === 'MedicaidApplication' ||
    deserialized.__typename === 'MonitorApplication'
  )
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications {
  __typename:
    | 'CharityCareApplication'
    | 'MedicaidApplication'
    | 'MonitorApplication'
    | 'RyanWhiteApplication'
    | 'SlideApplication'
  id: string
  benefit: BenefitType
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplicationsOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person {
  __typename: 'Person'
  id: string
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_personOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person => ({
  ...serialized,
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_personOrig => ({
  ...deserialized,
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person_openHouseholdMemberApplications
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
  person: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  person: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person(
    serialized.person
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  person: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication_person(
    deserialized.person
  ),
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplicationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications
): SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplicationsOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication {
  __typename: 'MedicaidApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  initialDateOfService: Date | null
  mcdType: string
  mcdSubtype: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  mcdType: deserializeMcdType(serialized.mcdType),
  mcdSubtype:
    serialized.mcdSubtype != null
      ? deserializeMcdSubtype(serialized.mcdSubtype)
      : serialized.mcdSubtype,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  mcdType: serializeMcdType(deserialized.mcdType),
  mcdSubtype:
    deserialized.mcdSubtype != null
      ? serializeMcdSubtype(deserialized.mcdSubtype)
      : deserialized.mcdSubtype,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact {
  __typename: 'Person'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContactOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContactOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication {
  __typename: 'MonitorApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  submitDate: Date | null
  applicationType: string | null
  submitMethod: string | null
  location: string | null
  countyName: string | null
  darSubmitDate: Date | null
  confirmationNumber: string | null
  policyId: string | null
  notes: string | null
  primaryPointOfContact: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact | null
  initialDateOfService: Date | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  submitDate:
    serialized.submitDate != null
      ? parseDate(serialized.submitDate)
      : serialized.submitDate,
  darSubmitDate:
    serialized.darSubmitDate != null
      ? parseDate(serialized.darSubmitDate)
      : serialized.darSubmitDate,
  primaryPointOfContact:
    serialized.primaryPointOfContact != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact(
          serialized.primaryPointOfContact
        )
      : serialized.primaryPointOfContact,
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  submitDate:
    deserialized.submitDate != null
      ? formatISODate(deserialized.submitDate)
      : deserialized.submitDate,
  darSubmitDate:
    deserialized.darSubmitDate != null
      ? formatISODate(deserialized.darSubmitDate)
      : deserialized.darSubmitDate,
  primaryPointOfContact:
    deserialized.primaryPointOfContact != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication_primaryPointOfContact(
          deserialized.primaryPointOfContact
        )
      : deserialized.primaryPointOfContact,
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication {
  __typename: 'CharityCareApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  dateOfApplication: Date | null
  requestedDateOfApplication: Date | null
  notes: string | null
  facility: string
  coveragePeriod: number | null
  charityCareType: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
  requestedDateOfApplication:
    serialized.requestedDateOfApplication != null
      ? parseDate(serialized.requestedDateOfApplication)
      : serialized.requestedDateOfApplication,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
  requestedDateOfApplication:
    deserialized.requestedDateOfApplication != null
      ? formatISODate(deserialized.requestedDateOfApplication)
      : deserialized.requestedDateOfApplication,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication {
  __typename: 'SlideApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  slideType: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  slideType: deserializeSlideType(serialized.slideType),
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  slideType: serializeSlideType(deserialized.slideType),
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication {
  __typename: 'RyanWhiteApplication'
  id: string
  benefit: BenefitType
  status: string
  createdAt: Date
  updatedAt: Date
  isUnclosableDueToMissingBenefitOutcomes: boolean
  accountNumber: string | null
  detailsUpdatedAt: Date
  readyForAudit: boolean
  initialDateOfService: Date | null
  receivedDate: Date | null
  notes: string | null
  facility: string
  dateOfApplication: Date | null
  coveragePeriod: number | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication => ({
  ...serialized,
  benefit: deserializeBenefit(serialized.benefit),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  detailsUpdatedAt: parseDate(serialized.detailsUpdatedAt),
  initialDateOfService:
    serialized.initialDateOfService != null
      ? parseDate(serialized.initialDateOfService)
      : serialized.initialDateOfService,
  receivedDate:
    serialized.receivedDate != null
      ? parseDate(serialized.receivedDate)
      : serialized.receivedDate,
  dateOfApplication:
    serialized.dateOfApplication != null
      ? parseDate(serialized.dateOfApplication)
      : serialized.dateOfApplication,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplicationOrig => ({
  ...deserialized,
  benefit: serializeBenefit(deserialized.benefit),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  detailsUpdatedAt: formatISO(deserialized.detailsUpdatedAt),
  initialDateOfService:
    deserialized.initialDateOfService != null
      ? formatISODate(deserialized.initialDateOfService)
      : deserialized.initialDateOfService,
  receivedDate:
    deserialized.receivedDate != null
      ? formatISODate(deserialized.receivedDate)
      : deserialized.receivedDate,
  dateOfApplication:
    deserialized.dateOfApplication != null
      ? formatISODate(deserialized.dateOfApplication)
      : deserialized.dateOfApplication,
})
export type SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application =
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication
  | SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_applicationOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application => {
  if (false || serialized.__typename === 'MedicaidApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication(
      serialized
    )
  if (false || serialized.__typename === 'MonitorApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication(
      serialized
    )
  if (false || serialized.__typename === 'CharityCareApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication(
      serialized
    )
  if (false || serialized.__typename === 'SlideApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication(
      serialized
    )
  if (false || serialized.__typename === 'RyanWhiteApplication')
    return deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication(
      serialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      serialized && (serialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application'
  )
}
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_applicationOrig => {
  if (false || deserialized.__typename === 'MedicaidApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MedicaidApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'MonitorApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_MonitorApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'CharityCareApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_CharityCareApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'SlideApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_SlideApplication(
      deserialized
    )
  if (false || deserialized.__typename === 'RyanWhiteApplication')
    return serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application_RyanWhiteApplication(
      deserialized
    )
  throw new TypeError(
    `Unexpected GraphQL union type ${
      deserialized && (deserialized as any).__typename
    } when trying to resolve ` +
      'SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application'
  )
}
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes {
  __typename: 'BenefitOutcome'
  id: string
  benefit: string
  coveredFacility: string
  outcome: string
  outcomeDate: Date | null
  deniedIneligibleReason: string | null
  effectiveStartDate: Date
  effectiveEndDate: Date
  insuranceName: string | null
  policyId: string | null
  notes: string | null
  patientResponsibility: number | null
  createdAt: Date
  updatedAt: Date
  application: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes => ({
  ...serialized,
  outcomeDate:
    serialized.outcomeDate != null
      ? parseDate(serialized.outcomeDate)
      : serialized.outcomeDate,
  effectiveStartDate: parseDate(serialized.effectiveStartDate),
  effectiveEndDate: parseDate(serialized.effectiveEndDate),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  application:
    serialized.application != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application(
          serialized.application
        )
      : serialized.application,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes
): SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomesOrig => ({
  ...deserialized,
  outcomeDate:
    deserialized.outcomeDate != null
      ? formatISODate(deserialized.outcomeDate)
      : deserialized.outcomeDate,
  effectiveStartDate: formatISODate(deserialized.effectiveStartDate),
  effectiveEndDate: formatISODate(deserialized.effectiveEndDate),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  application:
    deserialized.application != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes_application(
          deserialized.application
        )
      : deserialized.application,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents {
  __typename: 'Document'
  id: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documentsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents
): SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documentsOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles {
  __typename: 'DocumentFile'
  id: string
  name: string
  fileKey: string
  createdAt: Date
  documents: SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFilesOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles => ({
  ...serialized,
  createdAt: parseDate(serialized.createdAt),
  documents: serialized.documents.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles
): SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFilesOrig => ({
  ...deserialized,
  createdAt: formatISO(deserialized.createdAt),
  documents: deserialized.documents.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles_documents
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_accounts {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_accounts = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_accountsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_accounts => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_accounts = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_accounts
): SaveEligibilityDeterminations_saveEligibilityDeterminations_accountsOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy {
  __typename: 'User'
  id: string
  email: string
  name: string | null
  isCurrentUser: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdByOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdByOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo {
  __typename: 'Person'
  id: string
  firstName: string | null
  lastName: string | null
  middleName: string | null
  preferredName: string | null
  suffix: string | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedToOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedToOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks {
  __typename: 'Task'
  id: string
  taskType: string
  assignedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo
  createdBy: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy
  status: string
  note: string | null
  durationMin: number | null
  dueDate: Date
  linkedTo: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo
  updatedAt: Date
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasksOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks => ({
  ...serialized,
  assignedTo: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo(
    serialized.assignedTo
  ),
  createdBy: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy(
    serialized.createdBy
  ),
  dueDate: parseDate(serialized.dueDate),
  linkedTo: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo(
    serialized.linkedTo
  ),
  updatedAt: parseDate(serialized.updatedAt),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks
): SaveEligibilityDeterminations_saveEligibilityDeterminations_tasksOrig => ({
  ...deserialized,
  assignedTo: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_assignedTo(
    deserialized.assignedTo
  ),
  createdBy: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_createdBy(
    deserialized.createdBy
  ),
  dueDate: formatISODate(deserialized.dueDate),
  linkedTo: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks_linkedTo(
    deserialized.linkedTo
  ),
  updatedAt: formatISO(deserialized.updatedAt),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform {
  __typename: 'Webform'
  id: string
  name: string
  slug: string
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webformOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform => ({
  ...serialized,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform
): SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webformOrig => ({
  ...deserialized,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform {
  __typename: 'ReceivedWebform'
  id: string
  completedAt: Date
  response: ReceivedWebformResponse
  noPersonMatch: boolean
  createdAt: Date
  webform: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebformOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform => ({
  ...serialized,
  completedAt: parseDate(serialized.completedAt),
  response: parseReceivedWebformResponse(serialized.response),
  createdAt: parseDate(serialized.createdAt),
  webform: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform(
    serialized.webform
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform
): SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebformOrig => ({
  ...deserialized,
  completedAt: formatISO(deserialized.completedAt),
  response: serializeReceivedWebformResponse(deserialized.response),
  createdAt: formatISO(deserialized.createdAt),
  webform: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform_webform(
    deserialized.webform
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts {
  __typename: 'WebformMergeAttempt'
  id: string
  reviewed: boolean
  mergeResult: WebformMergeResult
  receivedWebform: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttemptsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts => ({
  ...serialized,
  mergeResult: parseWebformMergeResult(serialized.mergeResult),
  receivedWebform: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform(
    serialized.receivedWebform
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts
): SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttemptsOrig => ({
  ...deserialized,
  mergeResult: serializeWebformMergeResult(deserialized.mergeResult),
  receivedWebform: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts_receivedWebform(
    deserialized.receivedWebform
  ),
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount {
  __typename: 'Account'
  id: string
  hospitalAccountId: string | null
  dateOfService: Date
  timeOfService: string | null
  serviceTimeZone: string
  facility: string
  department: string
  location: string | null
  insuranceType: string
  status: string
  createdAt: Date
  updatedAt: Date
  notes: string | null
  accountAmount: number | null
  njmmisCheck: string | null
  previousInsurance: string | null
  invoiceMonth: string | null
  invoiceYear: string | null
  dischargeDate: Date | null
  isScheduled: boolean
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccountOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount => ({
  ...serialized,
  dateOfService: parseDate(serialized.dateOfService),
  createdAt: parseDate(serialized.createdAt),
  updatedAt: parseDate(serialized.updatedAt),
  njmmisCheck:
    serialized.njmmisCheck != null
      ? deserializeNjmmisCheckResult(serialized.njmmisCheck)
      : serialized.njmmisCheck,
  dischargeDate:
    serialized.dischargeDate != null
      ? parseDate(serialized.dischargeDate)
      : serialized.dischargeDate,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount
): SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccountOrig => ({
  ...deserialized,
  dateOfService: formatISODate(deserialized.dateOfService),
  createdAt: formatISO(deserialized.createdAt),
  updatedAt: formatISO(deserialized.updatedAt),
  njmmisCheck:
    deserialized.njmmisCheck != null
      ? serializeNjmmisCheckResult(deserialized.njmmisCheck)
      : deserialized.njmmisCheck,
  dischargeDate:
    deserialized.dischargeDate != null
      ? formatISODate(deserialized.dischargeDate)
      : deserialized.dischargeDate,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations {
  __typename: 'EligibilityDetermination'
  id: string
  benefit: string
  status: string
  reasonOrInfo: string | null
  secondaryInfo: string | null
  householdSizeDescription: string | null
  month: Date | null
  numMonths: number | null
  createdAt: Date
  additionalData: AdditionalData | null
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations => ({
  ...serialized,
  month:
    serialized.month != null ? parseDate(serialized.month) : serialized.month,
  createdAt: parseDate(serialized.createdAt),
  additionalData:
    serialized.additionalData != null
      ? parseAdditionalData(serialized.additionalData)
      : serialized.additionalData,
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminationsOrig => ({
  ...deserialized,
  month:
    deserialized.month != null
      ? formatISODate(deserialized.month)
      : deserialized.month,
  createdAt: formatISO(deserialized.createdAt),
  additionalData:
    deserialized.additionalData != null
      ? serializeAdditionalData(deserialized.additionalData)
      : deserialized.additionalData,
})
export interface SaveEligibilityDeterminations_saveEligibilityDeterminations {
  __typename: 'Person'
  id: string
  updatedAt: Date
  firstName: string | null
  middleName: string | null
  lastName: string | null
  suffix: string | null
  preferredName: string | null
  dob: Date | null
  gender: string | null
  ssn: string | null
  phoneNumbers: SaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers[]
  homeAddressStreet: string | null
  homeAddressCity: string | null
  homeAddressState: string | null
  homeAddressZip: string | null
  homeAddressComment: string | null
  mailingAddressStreet: string | null
  mailingAddressCity: string | null
  mailingAddressState: string | null
  mailingAddressZip: string | null
  mailingAddressComment: string | null
  email: string | null
  emailComment: string | null
  preferredLanguage: string | null
  hospitalPatientId: string | null
  livesInNj: boolean | null
  hasInsurance: boolean | null
  ciStatus: string | null
  fiveYearsInUs: boolean | null
  specialCategory: boolean | null
  ciDocumentType: string | null
  pregnant: boolean | null
  maritalStatus: string | null
  spouseLiveWithMe: boolean | null
  expectedChild: number | null
  taxFilingStatus: string | null
  claimedBySomeoneOtherThanParents: boolean | null
  livingWithParentsWhoDoNotFileJointly: boolean | null
  estTaxDependentCount: number | null
  taxDependentInclSpouseLiveWithClient: boolean | null
  estParentLiveWithClient: number | null
  estChildren19LiveWithClient: number | null
  estMinor19SiblingLiveWithClient: number | null
  estHouseholdIncome: number | null
  incomeSources: SaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources[]
  deductions: SaveEligibilityDeterminations_saveEligibilityDeterminations_deductions[]
  assets: SaveEligibilityDeterminations_saveEligibilityDeterminations_assets[]
  currentInsuranceName: string | null
  currentInsurancePolicyNo: string | null
  insuranceStartdate: Date | null
  njResidencyDoc: string | null
  ciDocumentName: string | null
  dateOfEntry: Date | null
  uscisNo: string | null
  prCardNo: string | null
  dueDate: Date | null
  spousePregnant: boolean | null
  isStudent: boolean | null
  dependentOfTaxFilerId: string | null
  changeJobInLast6Mon: string | null
  income: boolean | null
  whoSupportWithoutIncome: string | null
  othersSupportWithoutIncome: string | null
  selfSupportWithoutIncome: string | null
  insuranceLast3Months: boolean | null
  wantsCoverage: boolean | null
  alaskanNativeamerican: boolean | null
  fosterCareAfter18: boolean | null
  identityDocument: string | null
  desiredMco: string | null
  pcp: string | null
  childrenPcp: string | null
  note: string | null
  children18LiveWithClient: number | null
  minor18SiblingLiveWithClient: number | null
  pendingUsCitizenship: boolean | null
  livedInNjSinceMonth: string | null
  livedInNjSinceYear: string | null
  hasDeduction: boolean | null
  hasAsset: boolean | null
  noIncomeSinceMonth: string | null
  noIncomeSinceYear: string | null
  noAssetSinceMonth: string | null
  noAssetSinceYear: string | null
  homelessSinceMonth: string | null
  homelessSinceYear: string | null
  supporterRelationship: string | null
  supportSinceMonth: string | null
  supportSinceYear: string | null
  supportType: string[] | null
  supporterAddressStreet: string | null
  supporterAddressCity: string | null
  supporterAddressState: string | null
  supporterAddressZip: string | null
  supporterPhone: string | null
  othersAttestationWho: string | null
  othersAttestationRelationship: string | null
  othersAttestationPhone: string | null
  addressSinceMonth: string | null
  addressSinceYear: string | null
  race: string | null
  currentInsuranceType: string | null
  currentInsuranceIncludesDental: boolean | null
  noIdentityDocReason: string | null
  ownNonresidentProperty: boolean | null
  nonresidentPropertyMailingAddressStreet: string | null
  nonresidentPropertyMailingAddressCity: string | null
  nonresidentPropertyMailingAddressState: string | null
  nonresidentPropertyMailingAddressZip: string | null
  separatedSinceMonth: string | null
  separatedSinceYear: string | null
  dontLiveWithSpouse: boolean | null
  noJointAssetsWithSpouse: boolean | null
  noFinancialSupportFromSpouse: boolean | null
  notFiledJointlySince: string | null
  reasonNotFiling: string | null
  lastKnownAddressStreet: string | null
  lastKnownAddressCity: string | null
  lastKnownAddressState: string | null
  lastKnownAddressZip: string | null
  unreadMessageStatus: boolean | null
  triages: SaveEligibilityDeterminations_saveEligibilityDeterminations_triages[]
  openTriages: SaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages[]
  relationships: SaveEligibilityDeterminations_saveEligibilityDeterminations_relationships[]
  allApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications[]
  openApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications[]
  openHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications[]
  allOpenHouseholdMemberApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications[]
  openPrimaryPointOfContactApplications: SaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications[]
  benefitOutcomes: SaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes[]
  documentFiles: SaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles[]
  accounts: SaveEligibilityDeterminations_saveEligibilityDeterminations_accounts[]
  tasks: SaveEligibilityDeterminations_saveEligibilityDeterminations_tasks[]
  fieldsUpdatedAt: DeserializedFieldsUpdatedAt | null
  webformMergeAttempts: SaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts[]
  mostRecentAccount: SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount | null
  mostRecentEligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations[]
}
export const deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations = (
  serialized: SaveEligibilityDeterminations_saveEligibilityDeterminationsOrig
): SaveEligibilityDeterminations_saveEligibilityDeterminations => ({
  ...serialized,
  updatedAt: parseDate(serialized.updatedAt),
  dob: serialized.dob != null ? parseDate(serialized.dob) : serialized.dob,
  phoneNumbers: serialized.phoneNumbers.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers
  ),
  incomeSources: serialized.incomeSources.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources
  ),
  deductions: serialized.deductions.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_deductions
  ),
  assets: serialized.assets.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_assets
  ),
  insuranceStartdate:
    serialized.insuranceStartdate != null
      ? parseDate(serialized.insuranceStartdate)
      : serialized.insuranceStartdate,
  dateOfEntry:
    serialized.dateOfEntry != null
      ? parseDate(serialized.dateOfEntry)
      : serialized.dateOfEntry,
  dueDate:
    serialized.dueDate != null
      ? parseDate(serialized.dueDate)
      : serialized.dueDate,
  triages: serialized.triages.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages
  ),
  openTriages: serialized.openTriages.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages
  ),
  relationships: serialized.relationships.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships
  ),
  allApplications: serialized.allApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications
  ),
  openApplications: serialized.openApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications
  ),
  openHouseholdMemberApplications: serialized.openHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications
  ),
  allOpenHouseholdMemberApplications: serialized.allOpenHouseholdMemberApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications
  ),
  openPrimaryPointOfContactApplications: serialized.openPrimaryPointOfContactApplications.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications
  ),
  benefitOutcomes: serialized.benefitOutcomes.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes
  ),
  documentFiles: serialized.documentFiles.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles
  ),
  accounts: serialized.accounts.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_accounts
  ),
  tasks: serialized.tasks.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks
  ),
  fieldsUpdatedAt:
    serialized.fieldsUpdatedAt != null
      ? parseFieldsUpdatedAt(serialized.fieldsUpdatedAt)
      : serialized.fieldsUpdatedAt,
  webformMergeAttempts: serialized.webformMergeAttempts.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts
  ),
  mostRecentAccount:
    serialized.mostRecentAccount != null
      ? deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount(
          serialized.mostRecentAccount
        )
      : serialized.mostRecentAccount,
  mostRecentEligibilityDeterminations: serialized.mostRecentEligibilityDeterminations.map(
    deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations
  ),
})
export const serializeSaveEligibilityDeterminations_saveEligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations_saveEligibilityDeterminations
): SaveEligibilityDeterminations_saveEligibilityDeterminationsOrig => ({
  ...deserialized,
  updatedAt: formatISO(deserialized.updatedAt),
  dob:
    deserialized.dob != null
      ? formatISODate(deserialized.dob)
      : deserialized.dob,
  phoneNumbers: deserialized.phoneNumbers.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_phoneNumbers
  ),
  incomeSources: deserialized.incomeSources.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_incomeSources
  ),
  deductions: deserialized.deductions.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_deductions
  ),
  assets: deserialized.assets.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_assets
  ),
  insuranceStartdate:
    deserialized.insuranceStartdate != null
      ? formatISODate(deserialized.insuranceStartdate)
      : deserialized.insuranceStartdate,
  dateOfEntry:
    deserialized.dateOfEntry != null
      ? formatISODate(deserialized.dateOfEntry)
      : deserialized.dateOfEntry,
  dueDate:
    deserialized.dueDate != null
      ? formatISODate(deserialized.dueDate)
      : deserialized.dueDate,
  triages: deserialized.triages.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_triages
  ),
  openTriages: deserialized.openTriages.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openTriages
  ),
  relationships: deserialized.relationships.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_relationships
  ),
  allApplications: deserialized.allApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allApplications
  ),
  openApplications: deserialized.openApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openApplications
  ),
  openHouseholdMemberApplications: deserialized.openHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openHouseholdMemberApplications
  ),
  allOpenHouseholdMemberApplications: deserialized.allOpenHouseholdMemberApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_allOpenHouseholdMemberApplications
  ),
  openPrimaryPointOfContactApplications: deserialized.openPrimaryPointOfContactApplications.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_openPrimaryPointOfContactApplications
  ),
  benefitOutcomes: deserialized.benefitOutcomes.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_benefitOutcomes
  ),
  documentFiles: deserialized.documentFiles.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_documentFiles
  ),
  accounts: deserialized.accounts.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_accounts
  ),
  tasks: deserialized.tasks.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_tasks
  ),
  fieldsUpdatedAt:
    deserialized.fieldsUpdatedAt != null
      ? serializeFieldsUpdatedAt(deserialized.fieldsUpdatedAt)
      : deserialized.fieldsUpdatedAt,
  webformMergeAttempts: deserialized.webformMergeAttempts.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_webformMergeAttempts
  ),
  mostRecentAccount:
    deserialized.mostRecentAccount != null
      ? serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentAccount(
          deserialized.mostRecentAccount
        )
      : deserialized.mostRecentAccount,
  mostRecentEligibilityDeterminations: deserialized.mostRecentEligibilityDeterminations.map(
    serializeSaveEligibilityDeterminations_saveEligibilityDeterminations_mostRecentEligibilityDeterminations
  ),
})
export interface SaveEligibilityDeterminations {
  /**
   * Save eligibility determinations and person
   */
  saveEligibilityDeterminations: SaveEligibilityDeterminations_saveEligibilityDeterminations
}
export const deserializeSaveEligibilityDeterminations = (
  serialized: SaveEligibilityDeterminationsOrig
): SaveEligibilityDeterminations => ({
  ...serialized,
  saveEligibilityDeterminations: deserializeSaveEligibilityDeterminations_saveEligibilityDeterminations(
    serialized.saveEligibilityDeterminations
  ),
})
export const serializeSaveEligibilityDeterminations = (
  deserialized: SaveEligibilityDeterminations
): SaveEligibilityDeterminationsOrig => ({
  ...deserialized,
  saveEligibilityDeterminations: serializeSaveEligibilityDeterminations_saveEligibilityDeterminations(
    deserialized.saveEligibilityDeterminations
  ),
})
export interface SaveEligibilityDeterminationsVariables {
  determinations: EligibilityDeterminationInput[]
  person: UpdatePersonInput
  householdMembers?: ApplicationHouseholdMembersInput[] | null
}
export const deserializeSaveEligibilityDeterminationsVariables = (
  serialized: SaveEligibilityDeterminationsVariablesOrig
): SaveEligibilityDeterminationsVariables => ({
  ...serialized,
  determinations: serialized.determinations.map(
    deserializeEligibilityDeterminationInput
  ),
  person: deserializeUpdatePersonInput(serialized.person),
  householdMembers:
    serialized.householdMembers != null
      ? serialized.householdMembers.map(
          deserializeApplicationHouseholdMembersInput
        )
      : serialized.householdMembers,
})
export const serializeSaveEligibilityDeterminationsVariables = (
  deserialized: SaveEligibilityDeterminationsVariables
): SaveEligibilityDeterminationsVariablesOrig => ({
  ...deserialized,
  determinations: deserialized.determinations.map(
    serializeEligibilityDeterminationInput
  ),
  person: serializeUpdatePersonInput(deserialized.person),
  householdMembers:
    deserialized.householdMembers != null
      ? deserialized.householdMembers.map(
          serializeApplicationHouseholdMembersInput
        )
      : deserialized.householdMembers,
})
